import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-366f1946"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cancel-modal-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancelar documento?", -1))
const _hoisted_3 = { class: "cancel-modal-content" }
const _hoisted_4 = { class: "document-summary" }
const _hoisted_5 = { class: "document-icon" }
const _hoisted_6 = { class: "document-info" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "document-meta" }
const _hoisted_9 = { class: "document-progress" }
const _hoisted_10 = { class: "progress-bar" }
const _hoisted_11 = { class: "progress-label" }
const _hoisted_12 = { class: "signatories-section" }
const _hoisted_13 = { class: "section-title" }
const _hoisted_14 = {
  key: 0,
  class: "signatories-loading"
}
const _hoisted_15 = {
  key: 1,
  class: "signatories-empty"
}
const _hoisted_16 = {
  key: 2,
  class: "signatories-list"
}
const _hoisted_17 = { class: "signatory-info" }
const _hoisted_18 = { class: "signatory-name" }
const _hoisted_19 = { class: "signatory-email" }
const _hoisted_20 = { class: "signatory-status" }
const _hoisted_21 = {
  key: 0,
  class: "status-badge status-signed"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Assinou ")
const _hoisted_23 = {
  key: 1,
  class: "status-badge status-pending"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Pendente ")
const _hoisted_25 = {
  key: 2,
  class: "signature-date"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cancel-warning" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "warning-heading" }, " Esta ação não poderá ser revertida. "),
  /*#__PURE__*/_createElementVNode("div", { class: "warning-description" }, " Todos os signatários serão notificados e o documento não poderá mais ser assinado. ")
], -1))
const _hoisted_27 = { class: "cancel-modal-footer" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Voltar ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Sim, cancelar documento ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExclamationCircleOutlined = _resolveComponent("ExclamationCircleOutlined")!
  const _component_FilePdfOutlined = _resolveComponent("FilePdfOutlined")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_ClockCircleOutlined = _resolveComponent("ClockCircleOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    width: 570,
    centered: "",
    closable: !_ctx.isCancelling,
    "mask-closable": !_ctx.isCancelling,
    keyboard: !_ctx.isCancelling,
    "destroy-on-close": false,
    "wrap-class-name": "cancel-envelope-modal-wrapper",
    onCancel: _ctx.closeModal
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ExclamationCircleOutlined, { class: "warning-icon" }),
        _hoisted_2
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_a_button, {
          ref: "backButton",
          type: "primary",
          class: "back-button",
          disabled: _ctx.isCancelling,
          onClick: _ctx.closeModal
        }, {
          default: _withCtx(() => [
            _hoisted_28
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_a_button, {
          danger: "",
          class: "confirm-cancel-button",
          loading: _ctx.isCancelling,
          disabled: 
            _ctx.isCancelling ||
            _ctx.isLoadingDetails ||
            !_ctx.envelope ||
            _ctx.confirmationSeconds > 0
          ,
          onClick: _ctx.confirmCancellation
        }, {
          default: _withCtx(() => [
            (_ctx.confirmationSeconds > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" Aguarde " + _toDisplayString(_ctx.confirmationSeconds) + " segundos... ", 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_29
                ], 64))
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FilePdfOutlined)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "document-name",
              title: _ctx.envelope?.title
            }, _toDisplayString(_ctx.envelope?.title || 'Documento'), 9, _hoisted_7),
            _createElementVNode("div", _hoisted_8, " Criado em " + _toDisplayString(_ctx.formattedCreationDate), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "progress-bar-value",
                style: _normalizeStyle({ width: `${_ctx.progressPercentage}%` })
              }, null, 4)
            ]),
            _createElementVNode("span", _hoisted_11, _toDisplayString(Math.round(_ctx.progressPercentage)) + "% assinado ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, " Signatários (" + _toDisplayString(_ctx.signatories.length) + ") ", 1),
          (_ctx.isLoadingDetails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_a_spin, { tip: "Carregando signatários..." })
              ]))
            : (_ctx.signatories.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Nenhum signatário encontrado. "))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signatories, (signatory, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: signatory.id || `${signatory.email}-${index}`,
                      class: "signatory-item"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["signatory-avatar", { 'avatar-signed': _ctx.isSigned(signatory) }])
                      }, _toDisplayString(_ctx.getInitials(signatory.partName)), 3),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(signatory.partName || 'Nome não informado'), 1),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(signatory.email || signatory.phone || 'Contato não informado'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        (_ctx.isSigned(signatory))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                              _createVNode(_component_CheckCircleFilled),
                              _hoisted_22
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_23, [
                              _createVNode(_component_ClockCircleOutlined),
                              _hoisted_24
                            ])),
                        (_ctx.isSigned(signatory))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.getSignatureDate(signatory)), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _hoisted_26
      ])
    ]),
    _: 1
  }, 8, ["visible", "closable", "mask-closable", "keyboard", "onCancel"]))
}